/**
 * shortlist button feature for customers
 */

if (!customElements.get("shortlist-page")) {
  customElements.define(
    "shortlist-page",

    class ShortlistPage extends HTMLElement {
      constructor() {
        super();

        this.shortlistStore = {
          /**
           * @type Array<{productHandle: string, variant?:string, variantData?: JSON, data?: JSON }>
           */
          items: [],
        };

        this.emailHtmlBody = "";

        this.attachShadow({ mode: "open" });
      }

      connectedCallback() {
        /* first, check shortlisted items */
        const _shortlistString = localStorage.getItem("xtra__shortlist");

        try {
          const _shortlistData = JSON.parse(_shortlistString);
          if (Array.isArray(_shortlistData.items)) {
            // shortlistStore initialised, can compare
            this.shortlistStore = _shortlistData;
          }
        } catch (err) {
          // error parsing JSON, just reset the store;
          this.shortlistStore.items = [];
          this.saveShortlistStoreToLocalStorage();

          // start by showing empty state
          const emptyTemplate = document.querySelector("template#empty");
          this.shadowRoot.appendChild(emptyTemplate.content.cloneNode(true));
        }

        if (this.shortlistStore.items.length > 0) {
          const containerTemplate = document.querySelector(
            "template#shortlist-container",
          );

          const container = containerTemplate.content.cloneNode(true);
          const ulNode = container.querySelector("ul.shortlist-list");

          const formTemplate = document.querySelector(
            "template#shortlist-form",
          );
          const form = formTemplate.content.cloneNode(true);
          ulNode.after(form);

          const listItemTemplate = document.querySelector(
            "template#shortlist-list-item",
          );

          this.shortlistStore.items.forEach((item, idx) => {
            const listItemNode = listItemTemplate.content.cloneNode(true);
            listItemNode.childNodes.forEach((cn) => {
              if (cn?.classList?.contains("shortlist-list-item")) {
                cn.setAttribute("data-list-item-idx", idx.toString());
              }
            });

            fetch(
              `${window.Shopify.routes.root}products/${item.productHandle}.js`,
            )
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                const variant =
                  item.variant === undefined
                    ? data.variants.at(0)
                    : data.variants.find((a) => a.id === Number(item.variant));

                this.shortlistStore.items.at(idx).data = data;
                this.shortlistStore.items.at(idx).variantData = variant;

                const liNode = this.shadowRoot.querySelector(
                  `li[data-list-item-idx="${idx}"]`,
                );
                let html = liNode.innerHTML;

                html = html.replace(
                  "__IMG_SRC__",
                  `${variant?.featured_image?.src ?? `https:${data.featured_image}`}`,
                );

                html = html.replace("__IMG_ALT__", data.title);
                html = html.replace("__PRODUCT_TITLE__", data.title);
                html = html.replace("__PRODUCT_VENDOR__", data.vendor);
                html = html.replaceAll(
                  "__PRODUCT_URL__",
                  `/products/${data.handle}?view=b2b&variant=${variant.id}`,
                );

                liNode.removeAttribute("aria-hidden");

                liNode.innerHTML = html;

                if (variant?.title && variant.title !== "Default Title") {
                  const variantTitle = document.createElement("h4");
                  variantTitle.innerHTML = variant.title;
                  liNode.querySelector("h3").after(variantTitle);
                }

                const removeBtn = liNode.querySelector(
                  "button[data-action=xtra__remove-from-shortlist]",
                );

                if (removeBtn !== null) {
                  removeBtn.addEventListener("click", () => {
                    const toRemoveIdx = this.shortlistStore.items.findIndex(
                      (a) =>
                        a.productHandle === item.productHandle &&
                        a.variant === item.variant,
                    );
                    if (toRemoveIdx > -1) {
                      this.shortlistStore.items.splice(toRemoveIdx, 1);
                      this.saveShortlistStoreToLocalStorage();
                      liNode.remove();

                      if (this.shortlistStore.items.length === 0) {
                        const emptyTemplate =
                          document.querySelector("template#empty");
                        this.shadowRoot.replaceChildren(
                          emptyTemplate.content.cloneNode(true),
                        );
                      }
                    }
                  });
                }
              })
              .then(() =>
                fetch(
                  `${window.Shopify.routes.root}products/${item.productHandle}?view=metafields`,
                ),
              )
              .then((response) => response.text())
              .then((responseText) => {
                const metafields = JSON.parse(responseText);

                this.shortlistStore.items.at(idx).metafields = metafields;

                const liNode = this.shadowRoot.querySelector(
                  `li[data-list-item-idx="${idx}"]`,
                );

                if (metafields.spec_sheet?.url !== undefined) {
                  const specSheetLink = document.createElement("a");
                  specSheetLink.href = metafields.spec_sheet.url;
                  specSheetLink.innerText = "Spec Sheet";

                  liNode.querySelector(".links").append(specSheetLink);
                }

                if (metafields.website?.url !== undefined) {
                  const websiteLink = document.createElement("a");
                  websiteLink.href = metafields.website.url;
                  websiteLink.innerText = "Website";

                  liNode.querySelector(".links").append(websiteLink);
                }

                this.updateEmailHtmlBody("enquiry");
              })
              .catch((err) => {
                console.error(err);
              });

            ulNode.appendChild(listItemNode);
          });

          this.shadowRoot.appendChild(container);

          const showEmailBtn = this.shadowRoot.querySelector(
            "button[data-action='xtra__show-shortlist-email-form']",
          );

          const emailFormContainer = this.shadowRoot.querySelector(
            ".email-form-container",
          );
          const enquiryFormContainer = this.shadowRoot.querySelector(
            ".enquiry-form-container",
          );

          showEmailBtn.addEventListener(
            "click",
            function () {
              emailFormContainer.classList.remove("hidden");
              enquiryFormContainer.classList.add("hidden");
              this.updateEmailHtmlBody("email");
            }.bind(this),
          );

          const showEnquiryBtn = this.shadowRoot.querySelector(
            "button[data-action='xtra__show-shortlist-enquiry-form']",
          );

          showEnquiryBtn.addEventListener(
            "click",
            function () {
              emailFormContainer.classList.add("hidden");
              enquiryFormContainer.classList.remove("hidden");
              this.updateEmailHtmlBody("enquiry");
            }.bind(this),
          );

          const url = new URL(window.location);
          const posted = url.searchParams.get("contact_posted");
          if (posted === "true") {
            this.shadowRoot
              .querySelector("small#success")
              ?.removeAttribute("aria-hidden");
          }

          const emailForm = this.shadowRoot.querySelector(
            "form#EmailShortlistForm",
          );

          const enquiryForm = this.shadowRoot.querySelector(
            "form#EnquiryShortlistForm",
          );

          if (emailForm) {
            emailForm.addEventListener(
              "submit",
              async function (e) {
                e.preventDefault();

                const submitButton = e.target.querySelector(
                  "button[type=submit]",
                );

                submitButton.setAttribute("disabled", "true");
                submitButton.innerText = "Submitting...";

                try {
                  const fd = new FormData(e.target);
                  const email = fd.get("contact[email]");
                  const sendEmailShortlistReq = await fetch(
                    //"http://localhost:3000/shortlist-email",
                    //`https://server-helper.fly.dev/shortlist-email`,
                    `https://server-api.xtra.com.sg/shortlist-email`,
                    {
                      method: "POST",
                      body: JSON.stringify({
                        email,
                        HtmlBody: this.emailHtmlBody,
                        cfTurnstileToken: this.turnstileToken,
                      }),
                    },
                  );

                  const response = await sendEmailShortlistReq.json();

                  if (response.ok) {
                    vanillaToast.default(
                      "The shortlist will be sent to your email address. ",
                    );

                    window.turnstile.reset();

                    submitButton.removeAttribute("disabled");
                    submitButton.innerText = "Submit";
                  } else {
                    vanillaToast.error("An error has occurred. ");
                  }
                } catch (err) {
                  console.error(err);
                  vanillaToast.error("An error has occurred. ");
                }
              }.bind(this),
            );
          }

          if (enquiryForm) {
            enquiryForm.addEventListener(
              "submit",
              async function (e) {
                e.preventDefault();

                const submitButton = e.target.querySelector(
                  "button[type=submit]",
                );

                submitButton.setAttribute("disabled", "true");
                submitButton.innerText = "Submitting...";

                try {
                  const fd = new FormData(e.target);
                  const email = fd.get("contact[email]");
                  const phone = fd.get("contact[phone]");
                  const name = fd.get("contact[name]");
                  const company = fd.get("contact[company]");
                  const sendEnquiryShortlistReq = await fetch(
                    //"http://localhost:3000/shortlist-enquiry",
                    //`https://server-helper.fly.dev/shortlist-enquiry`,
                    `https://server-api.xtra.com.sg/shortlist-enquiry`,
                    {
                      method: "POST",
                      body: JSON.stringify({
                        email,
                        phone,
                        name,
                        company,
                        HtmlBody: this.emailHtmlBody,
                        cfTurnstileToken: this.turnstileToken,
                      }),
                    },
                  );

                  const response = await sendEnquiryShortlistReq.json();

                  if (response.ok) {
                    vanillaToast.default(
                      "Your shortlist has been sent to us. ",
                    );

                    window.turnstile.reset();

                    submitButton.removeAttribute("disabled");
                    submitButton.innerText = "Submit";
                  } else {
                    vanillaToast.error("An error has occurred. ");
                  }
                } catch (err) {
                  console.error(err);
                  vanillaToast.error("An error has occurred. ");
                }
              }.bind(this),
            );
          }
        } else {
          // show empty state
          const emptyTemplate = document.querySelector("template#empty");
          this.shadowRoot.appendChild(emptyTemplate.content.cloneNode(true));
        }

        if (typeof window.turnstile !== "undefined") {
          this.renderTurnstile();
        } else {
          window.addEventListener("turnstile:ready", () => {
            this.renderTurnstile();
          });
        }
      }

      renderTurnstile() {
        const container = document.querySelector(".turnstile-container");
        if (container && !container.hasChildNodes()) {
          this.turnstileWidgetId = window.turnstile.render(container, {
            // test dev
            // sitekey: "1x00000000000000000000AA",

            sitekey: "0x4AAAAAACJudVOBrpAnIKcS",

            callback: (token) => {
              this.turnstileToken = token;
            },
          });
        }
      }

      updateEmailHtmlBody(type) {
        const lines = this.shortlistStore.items.map((item) => {
          return `
<tr style="padding: 0; margin: 0; border: 0;" cellpadding="0" cellspacing="0">
<td width="150" style="width: 120px ;padding-bottom: 15px;">
<a href="https://xtrasg.myshopify.com/products/${item.data.handle}?variant=${item.variantData.id}&view=b2b" style="border: 0;">
<img src="${item.variantData?.featured_image?.src ?? `https:${item.data?.featured_image}`}" style="width: 100px; height: 100px; display: block;" />
</a>
</td><td width="450" style="width: 450px; padding-bottom: 15px;">
<strong>
<a href="https://xtrasg.myshopify.com/products/${item.data.handle}?variant=${item.variantData.id}&view=b2b" style="text-decoration: none; color: #000;">${item.data.title}</a></strong><br />
${item.variantData.title === "Default Title" ? "Default Variant" : item.variantData.title}<br /><br />
Brand: ${item.data.vendor}<br />
${item.metafields?.spec_sheet ? `<a href="${item.metafields.spec_sheet.url}">Spec Sheet</a> ` : ""}
${item.metafields?.website ? `<a href="${item.metafields.website.url}">Website</a> ` : ""}
</td></tr>
`;
        });

        const htmlStr =
          type === "enquiry"
            ? // enquiry
              `<div style="font-family: sans-serif; width: 570px; margin: 20px auto;">
<h1>A visitor has submitted a B2B shortlist enquiry. </h1>

<p>The visitor shortlisted the following items:</p>

<table><tbody>${lines.join("\n")}</tbody></table></div>`
            : // email to self
              `
<div style="font-family: sans-serif; width: 570px; margin: 20px auto;">
<h1>Here's your XTRA shortlist</h1>

<table><tbody>${lines.join("\n")}</tbody></table></div>`;
        this.emailHtmlBody = htmlStr;
      }

      saveShortlistStoreToLocalStorage() {
        localStorage.setItem(
          "xtra__shortlist",
          JSON.stringify(this.shortlistStore),
        );
      }
    },
  );
}
